module.exports = __webpack_public_path__ + "static/paidy-logo-color-bf967ba71077621ef58baba995a8a33e.png";